// extracted by mini-css-extract-plugin
module.exports = {"DateFieldInput":"styles_DateFieldInput__1YUy2"};